import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { useState } from "react";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import InputComponent from "V2.0/components/InputComponent";

export default function PromptVoiceAdd(props) {
  const { onVoiceAdd, onClose } = props;

  const [voiceName, setVoiceName] = useState("");

  const handleVoiceAdd = function () {
    const lifecycleCbs = {
      onInit: () => {
        message.loading("Creating voice");
      },
      onSuccess: () => {
        message.destroy();
        message.success("Voice created Successfully");
      },
      onError: (e) => {
        message.destroy();
        showErrorToast(e, "Failed to create designed voice");
      },
    };

    onVoiceAdd(voiceName, lifecycleCbs);
  };
  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>Add Voice</DialogTitle>
      <DialogBody>
        <InputComponent
          type="text"
          value={voiceName}
          label="Voice Name"
          onChange={(e) => setVoiceName(e.target.value)}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button onClick={handleVoiceAdd}>Add</Button>
      </DialogActions>
    </Dialog>
  );
}
